import React, { Component } from 'react';
import {uploadCarlaScenario} from "../../components/UserFunctions"

class UploadScenarioClosedLoop extends Component {
    constructor() {
        super()
        this.state = {
            name_file : "",
            description : "",
            content : "",
        }
		this.handleDescription = this.handleDescription.bind(this)
		this.handleContent = this.handleContent.bind(this)
		this.handleName = this.handleName.bind(this)
        this.onSubmit = this.onSubmit.bind(this);
    }
    
    handleName(e){
        const value = e.target.value;
        this.setState( (prevState) => {
            return {
                description: prevState.description,
                content: prevState.content,
                name_file : value,
            }
        })
    }

    handleDescription(e) {
        const value = e.target.value;
        this.setState( (prevState) => {
            return {
                description: value,
                content: prevState.content,
                name_file : prevState.name_file,
            }
        })
    }

    handleContent(e) {
        const value = e.target.value;
        this.setState( (prevState) => {
            return {
                description: prevState.description,
                content: value,
                name_file : prevState.name_file
            }
        })
    }

    onSubmit(e) {
        e.preventDefault();
        console.log(this.state);
        const upload_scenario_url = (window.location.origin).concat('/close_loop_upload_scenario')
        const data_to_api = {
                              description : this.state.description,
                              content : this.state.content,
                              name : this.state.name_file,
        }
        uploadCarlaScenario(upload_scenario_url, data_to_api).then((res) => {
            console.log(res)
          console.log("Uploaded CArla Scenario");
                this.setState((prevState) =>{
                    return {
                        ...prevState,
                        description : "",
                        content:"",
                        name_file:"",
                        }
                    })
                })
            }

    render() {
        return(
            <div data-test = 'closedLoopUploadScenarioClosedLoopComponent' className="container-fluid">
                <div className="row">
                  <div className="mt-5 mx-auto">
                    <div className="card" style={{ width: "800px" }}>
                        <div className="card">
                            <h1 className="card-header" style={{color:"white", fontSize: "100% !important", backgroundColor: "#757AF7"}}>Upload Carla Scenarios</h1>
                        </div>
                            <div className="card-body">
                                <form onSubmit={this.onSubmit}>
                                  <div className="form-group">
                                    <label htmlFor="name_file">Scenario Name</label>
                                    <input className="form-control" type="text" onChange={this.handleName}></input>
                                  </div>

                                  <div className="form-group">
                                    <label htmlFor="description">Scenario Description</label>
                                    <input className="form-control" type="text" onChange={this.handleDescription}></input>
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="xosc-content">Content</label>
                                    <textarea className="form-control" id="xosc-content" rows="5" onChange={this.handleContent}></textarea>
                                  </div>
                                  <div>

                                  </div>
                                   <button type="submit" className="btn">Submit</button>
                                </form>
                            </div>
                      </div>
                  </div>
                </div>
            </div>
        )
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default UploadScenarioClosedLoop
